import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <>
      <div className="container_footer bg-dark bg-gradient">
        <p className="copyright">Copyright 2022 © Filippo Zarba</p>
      </div>
    </>
  );
}

export default Footer;
